import i18n from '../../../../app/i18n';

export const actionTexts = {
  read_tile: {
    tileText: i18n.t('tileForm:interaction.types.action.readTile.tileText'),
    buttonText: i18n.t('tileForm:interaction.types.action.readTile.buttonText'),
  },
  take_action: {
    tileText: i18n.t('tileForm:interaction.types.action.takeAction.tileText'),
    buttonText: i18n.t(
      'tileForm:interaction.types.action.takeAction.buttonText',
    ),
  },
  read_article: {
    tileText: i18n.t('tileForm:interaction.types.action.readArticle.tileText'),
    buttonText: i18n.t(
      'tileForm:interaction.types.action.readArticle.buttonText',
    ),
  },
  share_on_social_media: {
    tileText: i18n.t(
      'tileForm:interaction.types.action.shareOnSocialMedia.tileText',
    ),
    buttonText: i18n.t(
      'tileForm:interaction.types.action.shareOnSocialMedia.buttonText',
    ),
  },
  visit_web_site: {
    tileText: i18n.t('tileForm:interaction.types.action.visitWebsite.tileText'),
    buttonText: i18n.t(
      'tileForm:interaction.types.action.visitWebsite.buttonText',
    ),
  },
  watch_video: {
    tileText: i18n.t('tileForm:interaction.types.action.watchVideo.tileText'),
    buttonText: i18n.t(
      'tileForm:interaction.types.action.watchVideo.buttonText',
    ),
  },
  custom: {
    tileText: i18n.t('tileForm:interaction.types.action.custom.tileText'),
    buttonText: i18n.t('tileForm:interaction.types.action.custom.buttonText'),
  },
};

export const quizTexts = {
  true_false: {
    tileText: i18n.t('tileForm:interaction.types.quiz.true_false.tileText'),
    buttonTextTrue: i18n.t(
      'tileForm:interaction.types.quiz.true_false.buttonTextTrue',
    ),
    buttonTextFalse: i18n.t(
      'tileForm:interaction.types.quiz.true_false.buttonTextFalse',
    ),
  },
  multiple_choice: {
    tileText: i18n.t(
      'tileForm:interaction.types.quiz.quiz_multiple_choice.tileText',
    ),
    buttonText: i18n.t(
      'tileForm:interaction.types.quiz.quiz_multiple_choice.buttonText',
    ),
  },
};

export const surveyTexts = {
  multiple_choice: {
    tileText: i18n.t(
      'tileForm:interaction.types.survey.survey_multiple_choice.tileText',
    ),
    buttonText: i18n.t(
      'tileForm:interaction.types.survey.survey_multiple_choice.buttonText',
    ),
  },
  feedback: {
    tileText: i18n.t('tileForm:interaction.types.survey.feedback.tileText'),
    buttonText: {
      stronglyAgree: i18n.t(
        'tileForm:interaction.types.survey.feedback.buttonText.stronglyAgree',
      ),
      agree: i18n.t(
        'tileForm:interaction.types.survey.feedback.buttonText.agree',
      ),
      neutral: i18n.t(
        'tileForm:interaction.types.survey.feedback.buttonText.neutral',
      ),
      disagree: i18n.t(
        'tileForm:interaction.types.survey.feedback.buttonText.disagree',
      ),
      stronglyDisagree: i18n.t(
        'tileForm:interaction.types.survey.feedback.buttonText.stronglyDisagree',
      ),
    },
  },
  free_response: {
    tileText: i18n.t(
      'tileForm:interaction.types.survey.free_response.tileText',
    ),
  },
  rsvp_to_event: {
    tileText: i18n.t(
      'tileForm:interaction.types.survey.rsvp_to_event.tileText',
    ),
    buttonText: {
      yes: i18n.t(
        'tileForm:interaction.types.survey.rsvp_to_event.buttonText.yes',
      ),
      no: i18n.t(
        'tileForm:interaction.types.survey.rsvp_to_event.buttonText.no',
      ),
      maybe: i18n.t(
        'tileForm:interaction.types.survey.rsvp_to_event.buttonText.maybe',
      ),
    },
  },
  change_email: {
    tileText: i18n.t('tileForm:interaction.types.survey.change_email.tileText'),
    buttonText: {
      changeMyEmail: i18n.t(
        'tileForm:interaction.types.survey.change_email.buttonText.changeMyEmail',
      ),
      keepCurrentEmail: i18n.t(
        'tileForm:interaction.types.survey.change_email.buttonText.keepCurrentEmail',
      ),
    },
  },
  invite_spouse: {
    tileText: i18n.t('tileForm:interaction.types.survey.invite_spouse.tileText'),
    buttonText: {
      haveDependentAndWantToInvite: i18n.t(
        'tileForm:interaction.types.survey.invite_spouse.buttonText.haveDependentAndWantToInvite',
      ),
      haveDependentAndDontWantToInvite: i18n.t(
        'tileForm:interaction.types.survey.invite_spouse.buttonText.haveDependentAndDontWantToInvite',
      ),
      dontHaveDependent: i18n.t(
        'tileForm:interaction.types.survey.invite_spouse.buttonText.dontHaveDependent',
      ),
    },
  }
};
